// types
import NestedSelectFilter from '@tajawal/web-flights-sdk/lib/stores/filter/base/nested-select-filter.store';
import { useService } from '@/contexts/ServiceContext';

// utils
import _get from 'lodash/get';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _concat from 'lodash/concat';

// types
import { FILTER_MAP, FLIGHT_LEG_TYPE_MAP } from '@tajawal/web-flights-sdk/lib/constants/filters.constants';

// hooks
import { useStateOfNestedSelectFilter } from '@/hooks/useStateOfNestedSelectFilter';
import { pushFilterChangeGtmEvent } from '@/utils/avoGtm.utils';

function useAirportFilter(filter: NestedSelectFilter, activeIndex: number) {
  const { state, toggle, reset, params, isDirty } = useStateOfNestedSelectFilter(filter);

  const { resources } = useService();
  const originFilterState = _get(state, `${activeIndex}.${FLIGHT_LEG_TYPE_MAP.ORIGIN}`, []);
  const destinationFilterState = _get(state, `${activeIndex}.${FLIGHT_LEG_TYPE_MAP.DESTINATION}`, []);

  function handleSelect({ type, code, selected }) {
    const direction = activeIndex === 0 ? 'departure' : 'return';
    const selectedAirports = _concat(
      _filter(params?.[activeIndex]?.[type], (c) => c !== code),
      selected ? [] : [code]
    ).join(',');
    toggle({ index: activeIndex, type, code }, true);
    pushFilterChangeGtmEvent(FILTER_MAP.AIRPORT, JSON.stringify({ direction, type, selectedAirports }));
  }

  function handleReset() {
    reset(true);
  }

  function resetTimeOption(activeIndex: number, direction) {
    const airports = _get(params, `[${activeIndex}].${direction}`);
    _forEach(airports, (airport) => {
      handleSelect({
        type: direction,
        code: airport,
        selected: false,
      });
    });
  }

  return {
    state,
    toggle,
    reset,
    isDirty,
    params,
    resources,
    originFilterState,
    destinationFilterState,
    handleSelect,
    handleReset,
    resetTimeOption,
  };
}

export default useAirportFilter;
